import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  forwardRef,
} from '@angular/core';
import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
} from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'epc-size-runs-quantities',
  templateUrl: './size-runs-quantities.component.html',
  styleUrls: ['./size-runs-quantities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => SizeRunsQuantitiesComponent),
    },
  ],
  standalone: false,
})
export class SizeRunsQuantitiesComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  public quantityControl = new UntypedFormControl(0);
  private destroy$ = new Subject<void>();

  @Input()
  public set quantity(value: number) {
    if (!this.quantityControl) {
      return;
    }

    if (this.quantityControl.value === value) {
      return;
    }

    this.quantityControl.patchValue(value ?? 0, { emitEvent: false });
  }

  @Input()
  public maxQuantity = Number.MAX_SAFE_INTEGER;

  @Output()
  public quantityChange = new EventEmitter<number>();

  public get quantityControlValue() {
    return this.quantityControl.value;
  }

  public ngOnInit() {
    this.subscribeQuantityChange();
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public applyQuantity() {
    this.quantityControl.patchValue(1);
  }

  public writeValue(quantity: number): void {
    this.quantity = quantity;
  }

  public registerOnChange(fn: () => {}): void {
    this.onChange = fn;
  }

  public registerOnTouched(): void {
    // interface; comment for Sonar
  }

  public onChange: (quantity: number) => void = () => {
    // interface; comment for Sonar
  };

  private subscribeQuantityChange() {
    this.quantityControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((value: number) => {
        this.quantityChange.emit(value);
      });
  }
}
